<template>
  <div class="cenario-container">
    <div
      v-show="dadosForm.tipoOperacao != 41"
      :class="['bloco-divisao', { 'bloco-multiplo': numeroCenarios > 1 }]"
    >
      <div>
        <h3>Você sabe o CNPJ do destinatário da mercadoria?</h3>
        <CenarioInput
          class="sabe-cnpj-input"
          placeholder="Selecione"
          :model="sabeCNPJDestinatario"
          :options="sabeCNPJDestinatarioOptions.map(p => p.label)"
          @update:model="update => (sabeCNPJDestinatario = update)"
          @selected="
            update => updateDados(update, 'sabeCNPJDestinatario', sabeCNPJDestinatarioOptions)
          "
        />
      </div>
    </div>
    <div
      v-show="dadosForm.sabeCNPJDestinatario == 1"
      :class="['cenario-bloco', 'bloco-divisao', { 'bloco-multiplo': numeroCenarios > 1 }]"
    >
      <div>
        <div>
          <h3>CNPJ</h3>
          <div class="cenario-cnpj">
            <CenarioInput
              tipo="texto"
              placeholder="Informe o CNPJ"
              mask="##.###.###/####-##"
              :cnpj="confirmaCnpj"
              :model="cnpjDestinatario"
              @update:model="update => (cnpjDestinatario = update)"
            />

            <BotaoPadrao
              arredondadoDireita
              tipo="icone"
              class="botao-padding"
              icone="search"
              :click="handleCnpj"
              cor="azul"
              padding="51"
              tamanho="15"
              :desabilita="cnpjDestinatario.length != 18"
              :tooltip="cnpjDestinatario.length != 18 ? 'Preencha o campo de CNPJ' : ''"
            />

            <!-- <button
              class="botao-procura-cnpj"
              @click="verificaCNPJ(id, cnpjDestinatario, 'destinatario', true)"
            >
              <font-awesome-icon icon="search" />
            </button> -->
          </div>
        </div>
      </div>
      <div>
        <h3>CNAE <span>*</span></h3>
        <CenarioInputCnae
          destinatario
          :id="id"
          :calculaDadosForm="calculaDadosForm"
          :calculaDados="calculaDados"
          :dadosForm="dadosForm"
          :filtros="filtros"
          :payloadCnae="payloadCnae"
          :openModalCnaeCompreende="openModalCnaeCompreende"
          :validaCampos="validaCampos"
          :exibeValidacao="exibeValidacao"
          :setAtividadeOptionsDes="setAtividadeOptionsDes"
          :cnaeRemetenteLista="listaCnae.listaCnaeRemetente"
          :cnaeDestinatarioLista="listaCnae.listaCnaeDestinatario"
          :carregandoAlgumaCnae="carregandoAlgumaCnae"
        />
      </div>
    </div>
    <div
      v-if="mostraAtividade || mostraTipoAtividade"
      :class="['cenario-bloco', 'bloco-divisao', { 'bloco-multiplo': numeroCenarios > 1 }]"
    >
      <div v-if="mostraAtividade">
        <h3>ATIVIDADE <span>*</span></h3>
        <CenarioInput
          placeholder="Selecione uma Atividade"
          nome="atividadeDestino"
          :validaCampos="validaCampos"
          :exibeValidacao="exibeValidacao"
          :model="atividadeDestino"
          :options="
            dadosForm.sabeCNPJDestinatario == 1
              ? atividadeOptionsLabel
              : filtros.atividade.valores.map(p => p.label)
          "
          @update:model="update => (atividadeDestino = update)"
          @selected="update => updateDados(update, 'atividadeDestino', filtros.atividade.valores)"
        />
      </div>
      <div v-if="mostraTipoAtividade">
        <h3>TIPO DE ATIVIDADE <span>*</span></h3>
        <CenarioInput
          placeholder="Selecione um Tipo de Atividade"
          nome="tipoAtividade"
          :validaCampos="validaCampos"
          :exibeValidacao="exibeValidacao"
          :model="tipoAtividade"
          :options="tipoAtividadeOptions"
          @update:model="update => (tipoAtividade = update)"
          @selected="update => updateDados(update, 'tipoAtividade', filtros.tipo_atividade.valores)"
        />
      </div>
    </div>
    <div
      v-if="
        (dadosForm.tipoAtividade != 56 &&
          (dadosForm.atividadeDestino != 50 || dadosForm.tipoAtividade != '') &&
          (dadosForm.atividadeDestino != 51 || dadosForm.tipoAtividade != '')) ||
          dadosForm.sabeCNPJDestinatario == 1
      "
      :class="['cenario-bloco', 'bloco-divisao', { 'bloco-multiplo': numeroCenarios > 1 }]"
    >
      <div>
        <h3>REGIME TRIBUTÁRIO <span>*</span></h3>
        <CenarioInput
          ref="teste"
          placeholder="Selecione um Regime Tributário"
          nome="regimeDestinatario"
          :validaCampos="validaCampos"
          :exibeValidacao="exibeValidacao"
          :model="regimeDestinatario"
          :options="regimeDestinatarioOptions"
          @update:model="update => (regimeDestinatario = update)"
          @selected="
            update => updateDados(update, 'regimeDestinatario', filtros.regime_tributacao.valores)
          "
        />
      </div>
    </div>
  </div>
</template>

<script>
import CenarioInput from "../CenarioInput/CenarioInput.vue";
import CenarioInputCnae from "./CenarioInputCnae.vue";
import BotaoPadrao from "@/components/BotaoPadrao/BotaoPadrao.vue";

export default {
  name: "CenarioCorpoDestinatario",

  components: { CenarioInput, CenarioInputCnae, BotaoPadrao },

  props: {
    impedimentoSnDes: Boolean,
    carregandoAlgumaCnae: Boolean,
    exibeValidacao: Boolean,
    id: Number,
    numeroCenarios: Number,
    calculaDadosForm: Function,
    calculaDados: Function,
    verificaCNPJ: Function,
    openModalCnaeCompreende: Function,
    dadosForm: Object,
    filtros: Object,
    payloadCnae: Object,
    validaCampos: Object,
    listaCnae: Object
  },

  data() {
    return {
      cnpjDestinatario: "",
      regimeDestinatario: "",
      tipoAtividade: "",
      atividadeDestino: "",
      sabeCNPJDestinatario: "Não",
      atividadeOptions: [],
      sabeCNPJDestinatarioOptions: [
        { label: "Não", value: "0" },
        { label: "Sim", value: "1" }
      ]
    };
  },

  created() {
    this.carregaDadosForm();
    this.cnpjDestinatario = this.dadosForm.cnpjDestinatario;
  },

  watch: {
    // ZERA O VALOR DE CNPJ DESTINATÁRIO DO FORMULÁRIO QUANDO INPUT NÃO TEM VALOR
    cnpjDestinatario() {
      if (this.cnpjDestinatario.length == 0) {
        this.calculaDadosForm("", "cnpjDestinatario");
      }
    },
    // ESCREVE NO INPUT VALOR DE CNPJ QUANDO ESTÁ NO FORMULÁRIO
    "dadosForm.cnpjDestinatario": {
      deep: true,
      handler() {
        this.$nextTick(() => {
          this.cnpjDestinatario = this.dadosForm.cnpjDestinatario;
        });
      }
    },
    // ZERA VALOR DE ATIVIDADE, TIPO DE ATIVIDADE E REGIME QUANDO ALTERA CNAE
    "dadosForm.cnaeDestinatario": {
      deep: true,
      handler() {
        this.calculaDadosForm("", "tipoAtividade");
        this.calculaDadosForm("", "regimeDestinatario");
        this.calculaDadosForm("", "atividadeDestino");
      }
    },
    // ZERA VALOR DE TIPO DE ATIVIDADE E REGIME QUANDO ALTERA ATIVIDADE
    "dadosForm.atividadeDestino": {
      deep: true,
      handler() {
        this.calculaDadosForm("", "tipoAtividade");
        this.calculaDadosForm("", "regimeDestinatario");
      }
    },
    // ZERA VALOR DE REGIME QUANDO ALTERA TIPO DE ATIVIDADE
    "dadosForm.tipoAtividade": {
      deep: true,
      handler() {
        this.calculaDadosForm("", "regimeDestinatario");
      }
    },
    // ZERA VALOR DE ATIVIDADE, TIPO DE ATIVIDADE E REGIME QUANDO ALTERA SE SABE CNPJ DESTINATÁRIO
    "dadosForm.sabeCNPJDestinatario": {
      deep: true,
      handler() {
        this.calculaDadosForm("", "atividadeDestino");
        this.calculaDadosForm("", "regimeDestinatario");
        this.calculaDadosForm("", "cnaeDestinatario");
      }
    },
    // ESCREVE NOS INPUTS O VALOR DO FORMULÁRIO QUANDO ALTERADO
    dadosForm: {
      deep: true,
      handler() {
        this.carregaDadosForm();
      }
    }
  },

  computed: {
    // CONDIÇÃO DE EXIBIÇÃO DO INPUT DE ATIVIDADE
    mostraAtividade() {
      return (
        !!this.atividadeOptions.length ||
        this.dadosForm.sabeCNPJDestinatario == 0 ||
        this.dadosForm.sabeCNPJDestinatario == ""
      );
    },
    // CONDIÇÃO DE EXIBIÇÃO DO INPUT DE TIPO DE ATIVIDADE
    mostraTipoAtividade() {
      return this.dadosForm.atividadeDestino == 50 || this.dadosForm.atividadeDestino == 51;
    },
    // TOOLTIP E INDICADOR DO ÍCONE DE CNPJ REMETENTE NO INPUT
    confirmaCnpj() {
      if (
        this.cnpjDestinatario == this.dadosForm.cnpjDestinatario &&
        this.dadosForm.cnpjDestinatario != ""
      ) {
        return {
          status: "confirma",
          titulo: `CNPJ: ${this.dadosForm.cnpjDestinatario} - Lista de CNAEs com base no CNPJ descrito.`
        };
      } else if (
        this.dadosForm.cnpjDestinatario != "" &&
        this.cnpjDestinatario != this.dadosForm.cnpjDestinatario
      ) {
        return {
          status: "alerta",
          titulo: `CNPJ: ${this.dadosForm.cnpjDestinatario} - Lista de CNAEs com base no CNPJ descrito.`
        };
      } else if (this.dadosForm.cnpjDestinatario == "") {
        return {
          status: "vazio",
          titulo: `Preencha o CNPJ e confirme no botão ao lado, ou selecione uma empresa cadastrada.`
        };
      }
    },
    // RETORNA AS OPÇÕES DE ATIVIDADE
    atividadeOptionsLabel() {
      if (this.atividadeOptions.length > 1) {
        let options = [];
        this.atividadeOptions.forEach((p, i) => {
          let label = this.filtros.atividade.valores.find(f => f.value == p).label;
          options[i] = label;
        });
        return options;
      }
      return [];
    },
    // RETORNA AS OPÇÕES DO TIPO DE ATIVIDADE
    tipoAtividadeOptions() {
      switch (this.dadosForm.atividadeDestino) {
        case "50":
          let tipo50 = ["55", "54", "52", "53"];
          tipo50.forEach((valor, index) => {
            let filtro = this.filtros.tipo_atividade.valores.find(p => p.value == valor).label;
            tipo50[index] = filtro;
          });
          return tipo50;
        case "51":
          let tipo51 = ["56", "57"];
          tipo51.forEach((valor, index) => {
            let filtro = this.filtros.tipo_atividade.valores.find(p => p.value == valor).label;
            tipo51[index] = filtro;
          });
          return tipo51;
        default:
          return [];
      }
    },
    // RETORNA AS OPÇÕES DO REGIME DESTINATÁRIO
    regimeDestinatarioOptions() {
      if (this.dadosForm.sabeCNPJDestinatario == "" || this.dadosForm.sabeCNPJDestinatario == "0") {
        switch (this.dadosForm.tipoAtividade) {
          case "52":
            let tipo52 = ["30", "31", "32"];
            tipo52.forEach((valor, index) => {
              let filtro = this.filtros.regime_tributacao.valores.find(p => p.value == valor).label;
              tipo52[index] = filtro;
            });
            return tipo52;
          case "53":
            let tipo53 = ["30", "31", "32"];
            tipo53.forEach((valor, index) => {
              let filtro = this.filtros.regime_tributacao.valores.find(p => p.value == valor).label;
              tipo53[index] = filtro;
            });
            return tipo53;
          case "54":
            let tipo54 = ["28"];
            tipo54.forEach((valor, index) => {
              let filtro = this.filtros.regime_tributacao.valores.find(p => p.value == valor).label;
              tipo54[index] = filtro;
            });
            return tipo54;
          case "55":
            let tipo55 = ["33"];
            tipo55.forEach((valor, index) => {
              let filtro = this.filtros.regime_tributacao.valores.find(p => p.value == valor).label;
              tipo55[index] = filtro;
            });
            return tipo55;
          case "56":
            let tipo56 = [];
            tipo56.forEach((valor, index) => {
              let filtro = this.filtros.regime_tributacao.valores.find(p => p.value == valor).label;
              tipo56[index] = filtro;
            });
            return tipo56;
          case "57":
            let tipo57 = ["30", "31", "32"];
            tipo57.forEach((valor, index) => {
              let filtro = this.filtros.regime_tributacao.valores.find(p => p.value == valor).label;
              tipo57[index] = filtro;
            });
            return tipo57;
          default:
            let def = ["30", "31", "32"];
            def.forEach((valor, index) => {
              let filtro = this.filtros.regime_tributacao.valores.find(p => p.value == valor).label;
              def[index] = filtro;
            });
            return def;
        }
      } else {
        let def = !this.impedimentoSnDes ? ["30", "31", "32"] : ["30", "31"];
        def.forEach((valor, index) => {
          let filtro = this.filtros.regime_tributacao.valores.find(p => p.value == valor).label;
          def[index] = filtro;
        });
        return def;
      }
    }
  },

  methods: {
    handleCnpj() {
      this.verificaCNPJ(this.id, this.cnpjDestinatario, "destinatario", true);
    },
    // ATUALIZA O FORMULÁRIO DE ACORDO COM OS VALORES LOCAIS
    updateDados(update, campo, caminho) {
      this[campo] = update;
      let valor = caminho.find(p => p.label == update);
      this.calculaDadosForm(valor ? valor.value : "", campo);
    },
    // ESCREVE OS VALORES DOS INPUTS DE ACORDO COM O FORMULÁRIO
    carregaDadosForm() {
      let dados = [
        { valor: "sabeCNPJDestinatario", filtro: this.sabeCNPJDestinatarioOptions },
        { valor: "atividadeDestino", filtro: this.filtros.atividade.valores },
        { valor: "tipoAtividade", filtro: this.filtros.tipo_atividade.valores },
        { valor: "regimeDestinatario", filtro: this.filtros.regime_tributacao.valores }
      ];
      dados.forEach(p => {
        this.carregaValor(p.valor, p.filtro);
      });
    },
    // FUNÇÃO CHAMADA PARA ESCREVER OS VALORES LOCAIS
    carregaValor(valor, filtro) {
      let resultado = filtro.find(p => p.value == this.dadosForm[valor]);
      this[valor] = resultado ? resultado.label : "";
    },
    // FUNÇÃO PASSADA POR PROPS PARA ESCREVER AS OPÇÕES ATIVIDADE DE ACORDO COM CNAE
    setAtividadeOptionsDes(atividades) {
      this.atividadeOptions = atividades;
    }
  }
};
</script>

<style lang="scss" scoped>
h3 {
  font-family: "Open Sans";
  font-weight: bold;
  font-size: 11px;
  text-transform: uppercase;
  color: #9ea2a7;
  span {
    color: red;
  }
}
.cenario-container {
  margin: 0.5rem 0;
}
.cenario-bloco {
  margin-top: 10px;
}
.botao-procura-cnpj {
  border-radius: 0 50px 50px 0;
  padding: 3px 45px;
  margin-left: 10px;
  background: var(--azul4);
  color: var(--branco);
  white-space: nowrap;
  transition: background 0.3s ease;
  &:hover {
    text-decoration: none;
    background: var(--azul2);
  }
  &:focus {
    background: #25beff;
  }
}
.cenario-cnpj {
  display: flex;
}
.sabe-cnpj-input {
  width: 140px;
}
</style>
